/**
 * Created by Rene Lopez on 11/02/16.
 */

// NewArchiveDetailsView.js

import $ from 'jquery';
import _ from 'lodash';

import { View,Model } from 'backbone';
import NotificationService from 'NotificationService.js';
import RestService from 'RestService.js';
import datepicker from 'jquery-ui/ui/widgets/datepicker.js';
import util from 'util/Util.js';
import SimpleConfirmModalView from 'common-views/SimpleConfirmModalView.js';

import eventBus  from 'EventBus.js';
import constants        from 'Constants.js';
import contentTemplate  from 'dashboard/settings/new-archive-details-view.ejs';
import undoService from 'UndoService.js'
import selectAllModal from 'dashboard/settings/SelectAllInstancesModal.js';
import Immutable        from 'immutable';
import zLib             from 'util/ZLib';
import Spinner                  from 'spin/spin';


class ListDetailsView extends View {

    initialize( opts ) {

        this.options = opts || {};
        this.template = contentTemplate;

        this.events = {
            'change input[name=dateOfFilter],input[name=beforeDate],input[name=betweenBeforeDate],input[name=betweenAfterDate],input[name=afterDate]' : 'updateDateFilter',
            'change select[name=status],input[name=name],select[name=dateOfType],select[name=maxRecords]' :'updateFilterOptions',
            'change select[name=maxRecordsForms]' :'updateMaxRecords',
            'click input[name=cancelArchive]':'cleanArchiveDetail',
            'click input[name=applyArchive],input[name=restoreArchive]':'applyArchive',
            'click input[name=deleteArchive]':'deleteArchive',
            'click #goToSettings': 'goToSettings',
            'click #goToArchiveSettings': 'goToArchiveSettings',
            'click #goToForms': 'goToForms',
            'click #goToEditForms': 'goToEditForms',
            'click #nextPage': 'nextPage',
            'click #previousPage': 'previousPage',
            'click #firstPage': 'firstPage', 
            'click #lastPage': 'lastPage'
        };
      
        this.model.set(
            {
                formModel: {
                    colModel: [
                        {
                            name: 'name',
                            index: 'name',
                            editable: false
                        }
                    ],
                    colNames: ['App']
                },
                formInstancesModel: {
                    colModel: [
                        {
                            name: 'id',
                            index: 'id',
                            editable: false,
                            hidden:true
                        },
                        {
                            name: 'name',
                            index: 'name',
                            editable: false
                        },
                        {
                            name: 'formName',
                            index: 'formName',
                            editable: false
                        },
                        {
                            name: 'isClosed',
                            index: 'isClosed',
                            editable: false
                        },
                        {
                            name: 'firstSubmissionDate',
                            index: 'firstSubmissionDate',
                            editable: false
                        },
                        {
                            name: 'lastSubmissionDate',
                            index: 'lastSubmissionDate',
                            editable: false
                        }
                    ],
                    colNames: ['','Name','App','Status','First Submission','Last Submission']
                }
            }, {silent: true});
        this.onResize();
        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    /* EVENTS */
    // Listening on the resize event of the window to call the resizeGrid method on the parent an adapt the grid.
    onResize(){
        $(window).on('resize',() => {this.resizeGrid();})
    }

    // Method that renders an scroll in the grid in order to navigate the same on small screens.
    resizeGrid(){
        let grid = $('.ui-jqgrid-btable');
        if (grid) {
            grid.each(function(index) {
                let gridId = $(this).attr('id');
                let gridParentWidth = $('#gbox_' + gridId).parent().width();
                $('#' + gridId).setGridWidth(gridParentWidth);
            });
        }
    }

    goToForms(e) {
        e.preventDefault();
        e.stopPropagation();

        eventBus.trigger("loadFormsView");
    }

    goToEditForms(e) {
        e.preventDefault();
        e.stopPropagation();

        eventBus.trigger("displayDefaultEditFormsDetailView");
    }

    remove(){
        $(window).off('resize');
        super.remove();
    }

    refresh(){
      if(this.model.get('isArchived')){
        eventBus.trigger(constants.EV_REFRESH_ARCHIVED_INSTANCE_DETAILS);  
      }
      else{
        eventBus.trigger(constants.EV_REFRESH_NEW_ARCHIVE_DETAILS);
      }
    }
    
    goToSettings(e) {
        e.preventDefault();
        e.stopPropagation();

        eventBus.trigger('loadSettingsView');
    }

    goToArchiveSettings(e) {
        e.preventDefault();
        e.stopPropagation();

        $('div.document-heading > a[data-target="#well-4"]').trigger('click');
    }
    /* EVENTS END */


    /* ACTION BUTTONS */

    applyArchive(ev) {

        $('<div id="spinner-overlay"></div>').appendTo('body');
        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        let grid = this.model.get(constants.GRID_LIST_FORMS_INSTANCES_CONTAINER);

        let allSelectedRows = grid.selectedItems,
            formInstancesXML=this.getFormInstancesXML(allSelectedRows),
            archiveType=this.model.get('isArchived') === true ? constants.ARCHIVE_INSTANCE : constants.UNARCHIVE_INSTANCE;
        RestService.archiveInstances(formInstancesXML,archiveType).then((results)=>{
            console.log("Archive Results",results);
            archiveType === constants.ARCHIVE_INSTANCE
                            ? NotificationService.success(allSelectedRows.size + ' app instances have been restored.')
                            : NotificationService.success(allSelectedRows.size + ' app instances have been archived.');
            this.cleanArchiveDetail();              
        }).catch((err=>{
            console.log('Error Archiving App Instances',err);
            NotificationService.error('Error Archiving App Instances '+err.MESSAGE);
           })).finally(() => {
            spinner.stop();
            $('#spinner-overlay').remove();
        });
    }


    getFormInstancesXML(selectedInstances){
        console.time("Build xml");
        
        let formInstancesXML='<FormInstances>';
        selectedInstances.forEach((item, key)=>{
                formInstancesXML += `<FormInstance id="${key}"/>`;
        });
        formInstancesXML+=`</FormInstances>`;
        console.log('FormInstancesXML',formInstancesXML);

        formInstancesXML=formInstancesXML.replace(/</g, '&lt;').replace(/>/g, '&gt;');
        console.log("FormInstancesXML",formInstancesXML);

        //TO DO: The next line should be enabled once the backend changes are finished to receive a compressed xml
        //formInstancesXML = zLib.compressForm(formInstancesXML);

        console.log('Is Archived',this.model.get('isArchived'));
        console.timeEnd("Build xml");
        return formInstancesXML;
    }

    deleteArchive(ev) {
        let grid = this.model.get(constants.GRID_LIST_FORMS_INSTANCES_CONTAINER),
            allSelectedRows = grid.selectedItems,
            formInstancesXML = this.getFormInstancesXML(allSelectedRows);

        let simpleModal = new SimpleConfirmModalView({
            model: new Model({
                subtitle: "Delete Archived App Instance",
                confirmationText: `You have been chosen to permanently delete the selected archived app instances.\n\nThis action cannot be undone.\n\nAre you sure you want to continue?`,
                height: 'auto',
                width: 400
            })
        });
        simpleModal.render().then((result) => {
            if (result === 'Ok') {

                $('<div id="spinner-overlay"></div>').appendTo('body');
                const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
                RestService.archiveInstances(formInstancesXML, constants.DELETE_INSTANCE).then((results) => {
                    console.log("Archive Results", results);
                    NotificationService.success(allSelectedRows.size + ' app instances have been deleted.');
                    this.cleanArchiveDetail();
                }).catch((err => {
                    console.log('Error Archiving App Instances', err);
                    NotificationService.error('Error Archiving App Instances ' + err.MESSAGE);
                })).finally(() => {
                    spinner.stop();
                    $('#spinner-overlay').remove();
                });
            }
        }).catch((err) => {
            console.log('Error Showing Action List Confirmation Message', err);
            NotificationService.error('Error Showing Action List Confirmation Message' + err.MESSAGE);
        });
    }

    cleanArchiveDetail() {
        console.log('Canceling Changes');

        this.cleanGrid(constants.GRID_LIST_FORMS_INSTANCES_CONTAINER);
        this.cleanGrid(constants.GRID_LIST_FORMS_CONTAINER);

        this.model.set('filterOptions',{
            status:'-1',
            name:'',
            dateOfFilter:'before',
            dateOfType:'first',
            firstSubmissionFrom:constants.DEFAULT_GROUP_ID,
            firstSubmissionTo:constants.DEFAULT_GROUP_ID,
            lastSubmissionFrom:constants.DEFAULT_GROUP_ID,
            lastSubmissionTo:constants.DEFAULT_GROUP_ID
        });

        this.model.set('filterFormList',[],{silent:true});
        this.render();//
    }
    /* ACTION BUTTONS END*/
    

    /* FORMS TABLE */
    filterBySelectedRows(grid) {
      
        let selectedItems = grid.selectedItems;
        let selectedForms = [];

        if(selectedItems.size > 0){
            $(".isFilter").prop('disabled', false);

            let formsXML = '<Forms>';
            selectedItems.forEach((item) => {
                selectedForms.push(item['@name']);
                formsXML += `<Form id="${item['@id']}"/>`
            });
            formsXML += '</Forms>';

            this.model.set('formsXML', formsXML.replace(/</g, '&lt;').replace(/>/g, '&gt;'), { silent: true });
            this.model.set('selectedForms', selectedForms, { silent: true });
            this.createDashboardGrid(constants.GRID_LIST_FORMS_INSTANCES_CONTAINER, [], this.getFormInstances, this.fillInstancesRow, this.model.get('formInstancesModel'), this.selectInstances, "@Id");
        }        
        else {
            const grid = this.model.get(constants.GRID_LIST_FORMS_INSTANCES_CONTAINER);
            grid.items = [];
            this.cleanGrid(constants.GRID_LIST_FORMS_INSTANCES_CONTAINER);
            this.updateInstancesSelectionText(grid);
            $(".isFilter").prop('disabled', true);
        }
    }

    selectForms(self, gridid) {
        const grid = self.model.get("#" + gridid.id);
        self.updateSelectionText(grid);
        self.filterBySelectedRows(grid);
    }
    

    updateSelectionText(grid) {

        const selectedItems = grid.selectedItems.size;
        const allItems = grid.items.length;
        const isArchived = this.model.get("isArchived");

        let text = "Select Apps and Filters to ";
        text += !isArchived ? "find Instances to Archive" : "View Archived Instances";

        if (selectedItems > 0) {
            text = `${selectedItems} of ${allItems} Apps Selected to find Instances to `;
            text += isArchived ? "View" : "Archive";
            $('input[name="cancelArchive"]').prop('disabled', false);
        }
        else{
            $('input[name="cancelArchive"]').prop('disabled', true);
        }
        $("#selectFormsHeader").text(text);
    }

    fillFormsRow(item) {
        return {
            'id': item['@id'],
            'name': item['@name']
        };
    }

    /* FORMS TABLE END */


    /* INSTANCES TABLE */
    fillInstancesRow(item) {
        return {
            'id': item['@Id'],
            'name': item['@Name'],
            'formName': item['@FormName'],
            'isClosed': util.isTrue(item['@IsClosed']) ? "Closed" : "Open",
            'firstSubmissionDate': item['@FirstSubmissionDate'],
            'lastSubmissionDate': item['@LastSubmissionDate']
        };
    }

    selectInstances(self, gridid){
        const grid = self.model.get("#" + gridid.id);
        self.updateInstancesSelectionText(grid);
    }

    updateInstancesSelectionText(grid) {

        const selectedItems = grid.selectedItems.size;
        
        let text = "App Instances";
        
        if (selectedItems > 0) {
            $('input[name="applyArchive"]').prop('disabled', false);
            $('input[name="restoreArchive"]').prop('disabled', false);
            $('input[name="deleteArchive"]').prop('disabled', false);
            text = `${selectedItems} out of ${grid.totalItems} App Instances Selected`;
        }
        else{
            $('input[name="applyArchive"]').prop('disabled', true);
            $('input[name="restoreArchive"]').prop('disabled', true);
            $('input[name="deleteArchive"]').prop('disabled', true);
        }
        $('h2[name="instancesCount"]').text(text);
    }    
    
    updateAppInstancesTotals(totalInstances){
        $('h2[name="instancesCount"]').text((totalInstances ? totalInstances + ' ' : '0') + ' App Instances found');
    }

    getFormInstances(self, grid, getIndex, fromPagination){

        return new Promise((resolve, reject) => {

            $('<div id="spinner-overlay"></div>').appendTo('body');
            const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));

            let formsXML = self.model.get('formsXML'),
                filterOptions = self.model.get('filterOptions');

            let index = getIndex(grid);
            let allSelected = grid.allSelected && !fromPagination;

            let filterObject = {
                formsXML: formsXML,
                name: filterOptions.name,
                status: filterOptions.status,
                firstSubmissionFrom: filterOptions.firstSubmissionFrom,
                firstSubmissionTo: filterOptions.firstSubmissionTo,
                lastSubmissionFrom: filterOptions.lastSubmissionFrom,
                lastSubmissionTo: filterOptions.lastSubmissionTo,
                maxRecords: !allSelected ? grid.maxRecords : grid.totalItems,
                startIndex: !allSelected ? index.start + 1 : 1,
                archived: self.model.get('isArchived') ? constants.ARCHIVE_INSTANCE : constants.UNARCHIVE_INSTANCE
            };

            RestService.searchFormInstances(filterObject).then((results) => {
                console.log("Search Results", results);
                let instanceList;
                if (!results.RESULT.RESPONSE.InstanceList) {
                    instanceList = [];
                }else{
                    instanceList = results.RESULT.RESPONSE.InstanceList.Instance instanceof Array
                        ? results.RESULT.RESPONSE.InstanceList.Instance
                        : [results.RESULT.RESPONSE.InstanceList.Instance];
                }

                grid.items = instanceList;
                grid.totalItems = parseInt(results.RESULT.RESPONSE.TotalRecords);
                self.updateAppInstancesTotals(grid.totalItems);
                resolve();
            }).catch((err => {
                console.log('Error Search App Instances Data', err);
                NotificationService.error('Error Search App Instances Data ' + err.MESSAGE);
                reject();
            })).finally(() => {
                spinner.stop();
                $('#spinner-overlay').remove();
            });
        });
    }

    /* INSTANCES TABLE END*/


    /* FILTERS */      
    injectDatePicker(selector) {
        const $dp = $(selector);

        $dp.datepicker({
            changeYear: true,
            showOn:"button",
            buttonImage:require('../../../../images/common/icons/calendar.png'),
            buttonImageOnly:true,
            buttonText:"Select date",
            changeMonth: true,
            gotoCurrent: true,
            defaultDate: new Date(),
            'disabled': true
        });
        return this;
    }

    updateFilterOptions(ev){
        let filterOptions=this.model.get('filterOptions');
        filterOptions[ev.currentTarget.name]=ev.currentTarget.value;
        this.model.set('filterOptions',filterOptions,{silent:true});
        console.log("Filter Options",filterOptions);
        this.updateDateFilter(ev);
    }

    updateDateFilter(ev){

        let filterOptions=this.model.get('filterOptions');
        filterOptions.firstSubmissionFrom=constants.DEFAULT_GROUP_ID;
        filterOptions.firstSubmissionTo=constants.DEFAULT_GROUP_ID;
        filterOptions.lastSubmissionFrom=constants.DEFAULT_GROUP_ID;
        filterOptions.lastSubmissionTo=constants.DEFAULT_GROUP_ID;
        filterOptions.dateOfFilter=$('input[name=dateOfFilter]:checked').val();
        $('.isDate').prop('disabled',true);

        filterOptions.maxRecords = $('select[name=maxRecords]').val();

        const beforeDate=$('input[name=beforeDate]');
        const beforeDateImg=$('input[name=beforeDate] ~ img');

        const afterDate=$('input[name=afterDate]');
        const afterDateImg=$('input[name=afterDate] ~ img');

        const betweenBeforeDate=$('input[name=betweenBeforeDate]');
        const betweenBeforeDateImg=$('input[name=betweenBeforeDate] ~ img');

        const betweenAfterDate=$('input[name=betweenAfterDate]');
        const betweenAfterDateImg=$('input[name=betweenAfterDate] ~ img');


        switch (filterOptions.dateOfFilter){
            case 'before':
                $('.isDate').not(ev.currentTarget).val('');
                beforeDate.prop('disabled',false);
                beforeDate.datepicker('enable');
                beforeDateImg.css('opacity',constants.CSS_CALENDAR_ENABLE);

                betweenBeforeDate.datepicker('disable');
                betweenBeforeDateImg.css( 'opacity', constants.CSS_CALENDAR_DISABLE);

                betweenAfterDate.datepicker('disable');
                betweenAfterDateImg.css( 'opacity', constants.CSS_CALENDAR_DISABLE);

                afterDate.datepicker('disable');
                afterDateImg.css( 'opacity', constants.CSS_CALENDAR_DISABLE);

                if(filterOptions.dateOfType==='first') {
                    filterOptions.firstSubmissionTo = beforeDate.val() || constants.DEFAULT_GROUP_ID;
                }
                else{
                    filterOptions.lastSubmissionTo = beforeDate.val() || constants.DEFAULT_GROUP_ID;
                }
                break;
            case 'between':
                $('.isDate').not('input[name="betweenBeforeDate"],input[name="betweenAfterDate"]').val('');
                $('input[name="betweenBeforeDate"],input[name="betweenAfterDate"]').prop('disabled',false);

                betweenBeforeDate.datepicker('enable');
                betweenBeforeDateImg.css('opacity',constants.CSS_CALENDAR_ENABLE);

                betweenAfterDate.datepicker('enable');
                betweenAfterDateImg.css('opacity',constants.CSS_CALENDAR_ENABLE);

                beforeDate.datepicker('disable');
                beforeDateImg.css( 'opacity', constants.CSS_CALENDAR_DISABLE);

                afterDate.datepicker('disable');
                afterDateImg.css( 'opacity', constants.CSS_CALENDAR_DISABLE);


                if(filterOptions.dateOfType==='first') {
                    filterOptions.firstSubmissionTo = betweenBeforeDate.val() || constants.DEFAULT_GROUP_ID;
                    filterOptions.firstSubmissionFrom = betweenAfterDate.val() || constants.DEFAULT_GROUP_ID;
                }
                else{
                    filterOptions.lastSubmissionTo = betweenBeforeDate.val() || constants.DEFAULT_GROUP_ID;
                    filterOptions.lastSubmissionFrom = betweenAfterDate.val() || constants.DEFAULT_GROUP_ID;
                }
                 break;
            case 'after':
                afterDate.prop('disabled',false);
                afterDate.datepicker('enable');
                afterDateImg.css('opacity',constants.CSS_CALENDAR_ENABLE);

                betweenBeforeDate.datepicker('disable');
                betweenBeforeDateImg.css( 'opacity', constants.CSS_CALENDAR_DISABLE);

                betweenAfterDate.datepicker('disable');
                betweenAfterDateImg.css( 'opacity', constants.CSS_CALENDAR_DISABLE);

                beforeDate.datepicker('disable');
                beforeDateImg.css( 'opacity', constants.CSS_CALENDAR_DISABLE);

                $('.isDate').not(ev.currentTarget).val('');
                if(filterOptions.dateOfType==='first') {
                    filterOptions.firstSubmissionFrom = afterDate.val() || constants.DEFAULT_GROUP_ID;
                }
                else{
                    filterOptions.lastSubmissionFrom = afterDate.val() || constants.DEFAULT_GROUP_ID;
                }
                break;
            default:
                break;
        }
        this.model.set('filterOptions',filterOptions,{silent:true});
        console.log("filterAfterDates",filterOptions);
        const grid = this.model.get(constants.GRID_LIST_FORMS_CONTAINER);
        this.filterBySelectedRows(grid);
    }

     /* FILTERS END */

    
    render() {
        const html = this.template( this.model.toJSON() );

        $("#dashboard-main-panel").html( html );


        this.createDashboardGrid(constants.GRID_LIST_FORMS_CONTAINER, this.model.get('formList'), false, this.fillFormsRow,  this.model.get('formModel'), this.selectForms, "@id");

        this.injectDatePicker('input[name=beforeDate]');
        this.injectDatePicker('input[name=betweenBeforeDate]');
        this.injectDatePicker('input[name=betweenAfterDate]');
        this.injectDatePicker('input[name=afterDate]');

        $('input[name=beforeDate] ~ img').css('opacity', constants.CSS_CALENDAR_DISABLE);
        $('input[name=betweenBeforeDate] ~ img').css('opacity', constants.CSS_CALENDAR_DISABLE);
        $('input[name=betweenAfterDate] ~ img').css('opacity', constants.CSS_CALENDAR_DISABLE);
        $('input[name=afterDate] ~ img').css('opacity', constants.CSS_CALENDAR_DISABLE);

        $(".isFilter").prop('disabled',true);
        $('input[name="applyArchive"]').prop('disabled', true);
        $('input[name="cancelArchive"]').prop('disabled', true);
        $('input[name="restoreArchive"]').prop('disabled', true);
        $('input[name="deleteArchive"]').prop('disabled', true);

        //Initialize empty grid for consistency with flash
        $(constants.GRID_LIST_FORMS_INSTANCES_CONTAINER).jqGrid(util.getGridObject(this,{ 
            height: 400,
            autowidth:true,
            colModel: this.model.get('formInstancesModel').colModel,
            colNames: this.model.get('formInstancesModel').colNames
        }));   

        this.delegateEvents();
        this.$el.css( 'cursor', 'default' );

        return this;
    }

     /* DASHBOARD GRID */

     setPagination(grid){
        const items = grid.items,
         maxRecords = grid.maxRecords,
         currentPage = grid.currentPage,
         totalPages = Math.ceil(grid.totalItems / maxRecords),
         pagination = 'Page ' + currentPage + ' of ' + totalPages,
         pager = $(grid.pager),
         paginationObject = pager.find('.pagination-text'),
         first =  $(grid.pager).find('[data-function=firstPage]'),
         next =  $(grid.pager).find('[data-function=nextPage]'),
         prev =  $(grid.pager).find('[data-function=previousPage]'),
         last =  $(grid.pager).find('[data-function=lastPage]');

         $(grid.pager).find('.archivePagination').addClass("disable_a_href");

         //Enable pagination
         if (totalPages > 1) {
            if (currentPage !== totalPages) {
                last.removeClass("disable_a_href");
                next.removeClass("disable_a_href");
            }

            if (currentPage > 1) {
                first.removeClass("disable_a_href");
                prev.removeClass("disable_a_href");
            }
        }
        
        grid.totalPages = totalPages;

        paginationObject.text(pagination);

        if(items.length > 0){
            pager.show();
        }   
        else{
            pager.hide();
        }    
    }

    updateMaxRecords(ev){
        let maxRecords = ev.currentTarget.value;
        let parentGrid = "#" + ev.currentTarget.dataset.table;

        let grid = this.model.get(parentGrid);
        grid.maxRecords = maxRecords;   

        this.cleanGrid(parentGrid);
        
        if(grid.afterSelect){
            grid.afterSelect(this, grid);
        }
        
        this.renderGrid(grid, parentGrid);
    }

    getIndex(grid) {      
        const   pageSize = grid.maxRecords,
                pageNumber = grid.currentPage,
                startIndex = (pageNumber - 1) * pageSize, 
                endIndex = pageNumber * pageSize;

        return {'start': startIndex, 'end': endIndex};
    }

    paginateDashboardGrid(grid){
        let items = grid.items;
        const index = this.getIndex(grid);
      
        if(!grid.itemsOnDemand){    
            grid.totalItems = items.length;        
            items = items.slice(index.start, index.end);            
        }       

        return items;
    }

    setPaginationEvent(grid, option, event){
        const button = $(grid.pager).find(`[data-function='${option}']`);
        button.off('click').on('click', event);
    }

    renderGrid (grid, gridid, fromPagination){
        if(grid.itemsOnDemand){
            grid.itemsOnDemand(this, grid, this.getIndex, fromPagination).then(() => {
                this.renderDashboardGrid(gridid); 
            });
        }
        else{
            this.renderDashboardGrid(gridid); 
        }
    }

    cleanGrid(gridId){

        const grid = this.model.get(gridId);
        grid.allSelected = false;
        grid.currentPage = 1;
        grid.totalItems = 0;
        grid.selectedItems = Immutable.Map();
        grid.totalPages = 1;
        //grid.items = [];

        $("#" + grid.id).jqGrid('GridUnload');
      
        this.renderDashboardGrid("#" + grid.id);
    }

    createDashboardGrid(gridid, items, getItems, fillRow, columns, afterSelect, idTag){
        let id = gridid.replace("#","");
        let gridElements = $(`[data-table='${id}']`);

        this.model.set(gridid, { 
            'id': id,
            'allSelected': false, 
            'currentPage': 1, 
            'maxRecords': 100, 
            'fillRow': fillRow,
            'itemsOnDemand': getItems, //If the items are retrieved from DB on every page
            'afterSelect': afterSelect,
            'items': items,
            'idTag': idTag,
            'totalItems': 0, 
            'pager': gridElements[0], 
            'selectedItems': Immutable.Map(),
            'totalPages': 1,
            'colModel': columns.colModel,
            'colNames': columns.colNames
        }, { silent: true });

        const grid = this.model.get(gridid);

        this.setPaginationEvent(grid, 'firstPage', (ev) => {
            ev.preventDefault();
            grid.currentPage = 1;
            this.renderGrid(grid, gridid, true);
        });

        this.setPaginationEvent(grid, 'nextPage', (ev) => {
            ev.preventDefault();
            grid.currentPage = grid.currentPage + 1;
            this.renderGrid(grid, gridid, true);
        });

        this.setPaginationEvent(grid, 'previousPage', (ev) => {
            ev.preventDefault();
            grid.currentPage = grid.currentPage - 1;
            this.renderGrid(grid, gridid, true);
        });

        this.setPaginationEvent(grid, 'lastPage', (ev) => {
            ev.preventDefault();
            grid.currentPage = grid.totalPages;
            this.renderGrid(grid, gridid, true);
        });       

        this.renderGrid(grid, gridid);
    }

    renderDashboardGrid(gridid){
        let grid = this.model.get(gridid);
        let itemsToRender = this.paginateDashboardGrid(grid);

        $(gridid).jqGrid('GridUnload');

        let gridData = [];      

        _.forEach(itemsToRender, (item, index) => {
            gridData.push(grid.fillRow(item));
        });

        let gridObject = util.getGridObject(this, {
            autowidth: true,
            data: gridData,
            multiselect:true,
            cellEdit:false,
            height: 400,
            scrollOffset: 0,
            colModel: grid.colModel,
            colNames: grid.colNames
        }, grid.afterSelect);
        
        $(gridid).jqGrid(gridObject);

        this.setSelectedItem(grid, gridid, itemsToRender);

        this.setPagination(grid);
    }   

    setSelectedItem(grid, gridid, items){

        let selectedItems = grid.selectedItems;
        const isChecked = document.getElementById(`cb_${grid.id}`).checked;
      
        if(!isChecked){
            items.forEach(item => {
                if(selectedItems.get(item[grid.idTag])){
                    $(gridid).jqGrid('setSelection', item[grid.idTag], false);          
                }
            });

            if(grid.allSelected){
                $(`#cb_${grid.id}`).prop('checked', true);
            }
        }
    }

    setRow(rowId, e){
        return true;
    }

    onCellSelect(){}

    onSelectRow(rowId, checked, e, gridid, afterSelect){

        let self = this;

        const grid = this.model.get("#" + e.currentTarget.id);
        let selectedItems = grid.selectedItems;
        let allItems = grid.items;

        if (checked) {
            let item = allItems.filter(item =>  item[grid.idTag] === rowId );
            selectedItems = selectedItems.set(rowId, item[0]);

            if(selectedItems.size === allItems.length){
                grid.allSelected = true;
                $(`#cb_${grid.id}`).prop('checked', true);
            }
        }
        else {
            grid.allSelected = false;
            selectedItems = selectedItems.delete(rowId);
        }
        
        grid.selectedItems = selectedItems;

        if (afterSelect) {
            afterSelect(self, gridid, '');
        }
    }

    onSelectAll(aRowids, status, gridid, afterSelect, e){
        let self = this;
        const grid = this.model.get("#" + gridid.id);

        if (grid && grid.items.length > 0) {
            let selectedItems = grid.selectedItems;

            const selectAll = new selectAllModal({
                model: new Model(),
                width: 420, height: "auto"
            });

            const setAllPage = (value, result) => {
                $('<div id="spinner-overlay"></div>').appendTo('body');
                const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
                let items = [];

                switch (result) {
                    case 'all':
                        items = grid.items;   
                        break;

                    case 'canceled':
                        selectedItems = Immutable.Map();

                        if (value) {
                            $(`#cb_${gridid.id}`).trigger('click');
                        }
                        break;

                    default:
                        items = this.paginateDashboardGrid(grid);
                        break;
                }

                items.forEach((item) => {
                    selectedItems = selectedItems.set(item[grid.idTag], item);
                });
                grid.selectedItems = selectedItems;

                $("#spinner-overlay").remove();
                spinner.stop();
            };

            if (status) {
                selectAll.render().then(result => {

                    grid.allSelected = result === "all";

                    if(grid.itemsOnDemand){
                        grid.itemsOnDemand(this, grid, this.getIndex).then(() => {
                            setAllPage(status, result);
                            if (afterSelect) {
                                afterSelect(self, gridid, result);
                            }
                        });
                    }
                    else{
                        setAllPage(status, result);
                        if (afterSelect) {
                            afterSelect(self, gridid, result);
                        }
                    }

                }).catch(err => console.log(err));
            }
            else {
                setAllPage(status, 'canceled');

                if (afterSelect) {
                    afterSelect(self, gridid, '');
                }
            }
        }
        
    }

    
    /* END DASHBOARD GRID */
}

export default ListDetailsView;
